
class ProductMediaGalleryNew extends HTMLElement {
  constructor() {
    super();
    this.main = null;
    this.thumbs = null;
  }

  connectedCallback() {
    this.initSplide();
  }

  disconnectedCallback() {
    this.destroySplide();
  }

  initSplide() {
    const mainEl = this.querySelector('#main-slider');
    const thumbsEl = this.querySelector('#thumbnail-slider');

    if (!mainEl || !thumbsEl) return;

    this.main = new Splide(mainEl, {
      type: 'fade',
      rewind: true,
      pagination: false,
      arrows: true,
    });

    this.thumbs = new Splide(thumbsEl, {
      autoWidth: true,
      gap: 10,
      rewind: true,
      pagination: false,
      arrows: false,
      isNavigation: true,
      focus: !!this.dataset.thumbCentered ? 'center' : 1
    });

    this.main.sync(this.thumbs);
    this.main.mount();
    this.thumbs.mount();
  }

  destroySplide() {
    if (this.main) {
      this.main.destroy(true);
      this.main = null;
    }

    if (this.thumbs) {
      this.thumbs.destroy(true);
      this.thumbs = null;
    }
  }
}

customElements.define('product-media-gallery-new', ProductMediaGalleryNew);
